import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { useIbUserAccountsGraphQLService } from '../useIbUserAccountsGraphQLService';

interface IbUserAccountsDynamicQueryAPI {
  getMultipleGraphQlQueriesResponse: UseMutateAsyncFunction<
    Record<string, any>,
    Error,
    string
  >;
  error: string | null;
  status: MutationStatus;
}

const useIbUserAccountsDynamicQueryAPI = (): IbUserAccountsDynamicQueryAPI => {
  const { ibUserAccountsGraphQLService } = useIbUserAccountsGraphQLService();

  const { mutateAsync, error, status } = useMutation(
    (query: string) => {
      return ibUserAccountsGraphQLService.ibUserAccountsGraphQlQuery(query);
    },
    {
      mutationKey: ['getMultipleGraphQlQueriesResponse']
    }
  );

  return {
    getMultipleGraphQlQueriesResponse: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useIbUserAccountsDynamicQueryAPI };
